module.exports = __webpack_public_path__ + "static/media/1-image.58823a59.svg";